import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
// import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { useIsTabletOrMobile } from "@/hooks/use-tablet-mobile";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAnimatedQuotes } from "@/hooks/useAnimatedQuotes";
const SignUpPage = () => {
  const navigate = useNavigate();
  const isTabletOrMobile = useIsTabletOrMobile();
  const isMobile = useIsMobile();
  const {
    currentQuote,
    isVisible
  } = useAnimatedQuotes();
  const {
    // signUpWithEmail, // Commented out - using Google-only sign up
    signInWithGoogle
  } = useAuth();
  const {
    toast
  } = useToast();
  // Email sign-up form state - commented out for Google-only sign up
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");
  // const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // Email sign-up handler - commented out for Google-only sign up
  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (password !== confirmPassword) {
  //     toast({
  //       title: "Password mismatch",
  //       description: "Passwords don't match. Please try again.",
  //       variant: "destructive"
  //     });
  //     return;
  //   }
  //   setIsLoading(true);
  //   try {
  //     const {
  //       error
  //     } = await signUpWithEmail(email, password, {
  //       full_name: name,
  //       date_of_birth: ""
  //     });
  //     if (error) {
  //       toast({
  //         title: "Sign up failed",
  //         description: error.message,
  //         variant: "destructive"
  //       });
  //     } else {
  //       toast({
  //         title: "Sign up successful!",
  //         description: "Please check your email to verify your account."
  //       });
  //       navigate("/welcome-video");
  //     }
  //   } catch (error) {
  //     toast({
  //       title: "An error occurred",
  //       description: "Please try again later.",
  //       variant: "destructive"
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const handleGoogleSignUp = async () => {
    setIsLoading(true);
    try {
      const {
        error
      } = await signInWithGoogle();
      if (error) {
        toast({
          title: "Google sign up failed",
          description: error.message,
          variant: "destructive"
        });
      }
    } catch (error) {
      toast({
        title: "An error occurred",
        description: "Please try again later.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };
  const FooterContent = () => (
    <div className="w-full">
      <div className="flex justify-between items-center text-sm text-gray-400 mb-4">
        <div className="flex space-x-2">
          <Link to="/terms" className="hover:text-gray-600 transition-colors">
            Terms of Use
          </Link>
          <Link to="/privacy" className="hover:text-gray-600 transition-colors">
            Privacy Policy
          </Link>
        </div>
        <p className="text-xs">© 2025 Studibudi</p>
      </div>
    </div>
  );
  if (isTabletOrMobile) {
    return <div className={`min-h-screen flex flex-col bg-app-background`}>
      {/* Top Navigation */}
      <nav className="w-full px-4 h-[58px] flex items-center">
        <div className="flex justify-start">
          <img src="/Logo/sblogo.png" alt="Studibudi Logo" className="h-6 w-auto" />
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div style={!isMobile ? {
            backdropFilter: 'blur(40px)'
          } : {
            backdropFilter: 'blur(40px)'
          }} className={`backdrop-blur-3xl rounded-2xl`}>
            {/* Sign Up Form */}
            <div className="space-y-6">
              <div className="text-center">
                <h2 className="text-xl font-medium text-gray-900 mb-6">Create your account</h2>
                <p className="text-sm text-gray-600 mb-8">Sign up using your Google account to get started</p>
              </div>

              {/* Email Sign Up Form - Commented out for Google-only sign up */}
              {/* 
              <form onSubmit={handleSubmit} className="space-y-3">
                <div className="space-y-2">
                  <Label htmlFor="name" className="text-sm font-medium text-gray-700">Full Name</Label>
                   <Input id="name" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="John Doe" required disabled={isLoading} className="w-full h-10 px-4 bg-gray-100 border border-gray-300 rounded-2xl text-gray-800 placeholder:text-gray-400 placeholder:font-light focus:outline-none focus:ring-0" />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="email" className="text-sm font-medium text-gray-700">Email</Label>
                   <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="john@example.com" required disabled={isLoading} className="w-full h-10 px-4 bg-gray-100 border border-gray-300 rounded-2xl text-gray-800 placeholder:text-gray-400 placeholder:font-light focus:outline-none focus:ring-0" />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="password" className="text-sm font-medium text-gray-700">Password</Label>
                   <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Create a strong password" required disabled={isLoading} className="w-full h-10 px-4 bg-gray-100 border border-gray-300 rounded-2xl text-gray-800 placeholder:text-gray-400 placeholder:font-light focus:outline-none focus:ring-0" />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="confirmPassword" className="text-sm font-medium text-gray-700">Confirm Password</Label>
                   <Input id="confirmPassword" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirm your password" required disabled={isLoading} className="w-full h-10 px-4 bg-gray-100 border border-gray-300 rounded-2xl text-gray-800 placeholder:text-gray-400 placeholder:font-light focus:outline-none focus:ring-0" />
                </div>

                <div className="pt-3">
                   <Button type="submit" className="w-full h-12 bg-black hover:bg-gray-800 text-white font-medium rounded-2xl border-0 shadow-none" disabled={isLoading}>
                    {isLoading ? <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                        Signing up...
                      </> : "Sign up"}
                  </Button>
                </div>
              </form>

              <div className="text-center text-gray-400 text-sm my-4">or</div>
              */}

              {/* Google Sign Up - Primary Option */}
              <div className="space-y-3 mb-6">
                <Button variant="outline" className="w-full h-14 border-2 border-blue-200 hover:bg-blue-50 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all" onClick={handleGoogleSignUp} disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 mr-3"></div>
                      Signing up...
                    </>
                  ) : (
                    <>
                      <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24">
                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                      </svg>
                      Continue with Google
                    </>
                  )}
                </Button>
              </div>

              {/* Links */}
              <div className="flex justify-between text-sm mt-6 mb-6">
                <span className="text-gray-600 mr-1">Already have an account?</span>
                <Link to="/login" className="text-blue-600 hover:text-blue-700 transition-colors">
                  Log In
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer at bottom */}
      <footer className="w-full px-4 pb-4">
        <FooterContent />
      </footer>
    </div>;
  }

  // Desktop layout with equal space distribution
  return <div className="min-h-screen flex flex-col bg-app-background">
    {/* Top Navigation */}
    <nav className="w-full px-4 h-[58px] flex items-center">
      <div className="flex justify-start">
        <img src="/Logo/sblogo.png" alt="Studibudi Logo" className="h-6 w-auto" />
      </div>
    </nav>

    {/* Main Content */}
    <div className="flex-1 flex items-center justify-center px-[80px]">

      {/* Sign Up Form - takes exactly half the space */}
      <div className="flex-1 flex items-center justify-center">
        <div style={{
          backdropFilter: 'blur(40px)'
        }} className="w-full backdrop-blur-3xl max-w-md rounded-2xl">
          {/* Sign Up Form */}
          <div className="space-y-6">
            <div className="text-center">
              <h2 className="text-xl font-medium text-gray-900 mb-6">Create your account</h2>
              <p className="text-sm text-gray-600 mb-8">Sign up using your Google account to get started</p>
            </div>

            {/* Email Sign Up Form - Commented out for Google-only sign up */}
            {/* 
            <form onSubmit={handleSubmit} className="space-y-3">
              <div className="space-y-2">
                <Label htmlFor="name" className="text-sm font-medium text-gray-700">Full Name</Label>
                 <Input id="name" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="John Doe" required disabled={isLoading} className="w-full h-10 px-4 bg-gray-100 border border-gray-300 rounded-2xl text-gray-800 placeholder:text-gray-400 placeholder:font-light focus:outline-none focus:ring-0" />
              </div>

              <div className="space-y-2">
                <Label htmlFor="email" className="text-sm font-medium text-gray-700">Email</Label>
                 <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="john@example.com" required disabled={isLoading} className="w-full h-10 px-4 bg-gray-100 border border-gray-300 rounded-2xl text-gray-800 placeholder:text-gray-400 placeholder:font-light focus:outline-none focus:ring-0" />
              </div>

              <div className="space-y-2">
                <Label htmlFor="password" className="text-sm font-medium text-gray-700">Password</Label>
                 <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Create a strong password" required disabled={isLoading} className="w-full h-10 px-4 bg-gray-100 border border-gray-300 rounded-2xl text-gray-800 placeholder:text-gray-400 placeholder:font-light focus:outline-none focus:ring-0" />
              </div>

              <div className="space-y-2">
                <Label htmlFor="confirmPassword" className="text-sm font-medium text-gray-700">Confirm Password</Label>
                 <Input id="confirmPassword" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirm your password" required disabled={isLoading} className="w-full h-10 px-4 bg-gray-100 border border-gray-300 rounded-2xl text-gray-800 placeholder:text-gray-400 placeholder:font-light focus:outline-none focus:ring-0" />
              </div>

              <div className="pt-3">
                <Button type="submit" className="w-full h-12 bg-black hover:bg-gray-800 text-white font-medium rounded-2xl border-0 shadow-none" disabled={isLoading}>
                  {isLoading ? <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Signing up...
                    </> : "Sign up"}
                </Button>
              </div>
            </form>

            <div className="text-center text-gray-400 text-sm my-4">or</div>
            */}

            {/* Google Sign Up - Primary Option */}
            <div className="space-y-3 mb-6">
              <Button variant="outline" className="w-full h-14 border-2 border-blue-200 hover:bg-blue-50 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all" onClick={handleGoogleSignUp} disabled={isLoading}>
                {isLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 mr-3"></div>
                    Signing up...
                  </>
                ) : (
                  <>
                    <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24">
                      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                    </svg>
                    Continue with Google
                  </>
                )}
              </Button>
            </div>

            {/* Links */}
            <div className="flex justify-between text-sm mt-6 mb-3">
              <span className="text-gray-600 mr-1">Already have an account?</span>
              <Link to="/login" className="text-blue-600 hover:text-blue-700 transition-colors">
                Log In
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Footer at bottom */}
    <footer className="w-full px-4 pb-4">
      <FooterContent />
    </footer>
  </div>;
};
export default SignUpPage;